"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Logo_1 = require("./Logo");
exports.default = Logo_1.default;
//# sourceMappingURL=index.js.map